import React from 'react';
import { Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import Classe from 'app/entities/classe/index';
import Login from 'app/modules/login/login';
import Surveillant from './entities/surveillant/index';
import Register from 'app/modules/account/register/register';
import Activate from 'app/modules/account/activate/activate';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import Logout from 'app/modules/login/logout';
import Home from 'app/modules/home/home';
import Entities from 'app/entities';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PageNotFound from 'app/shared/error/page-not-found';
import { AUTHORITIES } from 'app/config/constants';
import Configurations from './entities/appConfig';

const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
  loading: () => <div>loading ...</div>,
});

const Admin = Loadable({
  loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
  loading: () => <div>loading ...</div>,
});

const Routes = () => {
  return (
    <div className="view-routes">
      <Switch>
        <ErrorBoundaryRoute path="/" exact component={Login} />
        <ErrorBoundaryRoute path="/logout" component={Logout} />
        <ErrorBoundaryRoute path="/account/register" component={Register} />
        <ErrorBoundaryRoute path="/account/activate/:key?" component={Activate} />
        <ErrorBoundaryRoute path="/account/reset/request" component={PasswordResetInit} />
        <ErrorBoundaryRoute path="/account/reset/finish/:key?" component={PasswordResetFinish} />
        <ErrorBoundaryRoute path="/configuration" component={Configurations} />
        <PrivateRoute path="/admin" component={Admin} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
        <PrivateRoute
          path="/account"
          component={Account}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.DIRECTEUR,
            AUTHORITIES.DIRECTEUR_ETUDE,
            AUTHORITIES.COMPTABLE,
            AUTHORITIES.SURVEILLANT_GENERAL,
            AUTHORITIES.SECRETAIRE,
          ]}
        />
        <PrivateRoute
          path="/home/:ecoleid/:anneeScolaireId"
          component={Home}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.DIRECTEUR,
            AUTHORITIES.DIRECTEUR_ETUDE,
            AUTHORITIES.COMPTABLE,
            AUTHORITIES.SURVEILLANT_GENERAL,
            AUTHORITIES.SECRETAIRE,
          ]}
        />
        <PrivateRoute
          path="/"
          component={Entities}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.DIRECTEUR,
            AUTHORITIES.DIRECTEUR_ETUDE,
            AUTHORITIES.COMPTABLE,
            AUTHORITIES.SURVEILLANT_GENERAL,
            AUTHORITIES.PROFESSEUR,
            AUTHORITIES.SECRETAIRE,
          ]}
        />
        <ErrorBoundaryRoute component={PageNotFound} />
      </Switch>
    </div>
  );
};

export default Routes;
